<template>
    <div>
        <div
        class="widget-render-file d-flex justify-center align-center">
            <v-icon
            @click="dialogRander = !dialogRander"
            large
            :color="$mainColor"
            >
            mdi-help-circle-outline
            </v-icon>
        </div>
        <v-dialog max-width="700px" v-model="dialogRander">
            <widget-render-file-layouts
                :name="name"
                @close="dialogRander = $event"
                @search="search = $event"
            />
        </v-dialog>
    </div>
</template>
<script>
import WidgetRenderFileLayouts from '../../layouts/WidgetRenderFile-Layouts.vue'

export default {
    name: 'RenderFileWidget',
    props: {
        name: String
    },
    data() {
        return {
            dialogRander: false,
            search: ''
        }
    },
    components: {
        WidgetRenderFileLayouts
    },
}
</script>
<style scoped>
.widget-render-file {
    max-width: 700px;
    width: 100%;
    background: white;
    width: 60px;
    height: 60px;
    border-radius: 40%;
    position: fixed;
    bottom: 100px;
    right: 25px;
    cursor: pointer;
    z-index: 10;
    box-shadow: 2px 2px 6px rgba(0,0,0,.08);
}
</style>